import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface HotComicsProps {
  comics: Comic[];
}

export default function HotComics({ comics }: HotComicsProps) {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">热门推荐</h2>
            <p className="text-sm text-foreground-500 mt-2">最受读者欢迎的韩国漫画作品</p>
          </div>
          <Link to="/category/action" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors">
            查看全部 <i className="ri-arrow-right-line ml-1" />
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
          {comics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
              data-product-shop
            >
              <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4] bg-background-200">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  title={`${comic.title} - 韩国漫画`}
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-white text-xs rounded-md font-medium">
                    {index + 1}
                  </span>
                </div>
                {comic.status === '连载中' && (
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded-md font-medium">
                      连载
                    </span>
                  </div>
                )}
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                {comic.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-accent-500 text-xs" />
                </div>
                <span className="text-xs text-foreground-500">{comic.rating}</span>
                <span className="text-xs text-foreground-400">· {comic.views.toLocaleString()} 阅读</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}